import axios from "axios";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  updateFtTabStatus,
  getFtTabStatus,
} from "../../../services/yourAssets/CommonServices";
import { getSBTextStatus } from "../../../utils/statusViewUtilities";
import { getUserIdFromLocalStorage } from "../../../utils/Utilities";
const initialState = {
  fTSuggestionBoxText: [],

  loading: false,

  error: "",
};

export const getFtOnBoardingList = createAsyncThunk(
  //action type string
  "ftOnBoarding/getFtOnBoarding",
  // callback function
  async (thunkAPI) => {
    let uID = getUserIdFromLocalStorage();
    const suggestionBoxTextList = await getSBTextStatus(getFtTabStatus, uID);
    return suggestionBoxTextList;
  }
);

export const ftOnBoardingSlice = createSlice({
  name: "ftOnBoarding",
  initialState,
  reducers: {
    visited: (state, payLoad) => {
      state.fTSuggestionBoxText[0].status = true;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getFtOnBoardingList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getFtOnBoardingList.fulfilled, (state, action) => {
      state.loading = false;
      state.fTSuggestionBoxText = action.payload;
      state.error = "";
    });
    builder.addCase(getFtOnBoardingList.rejected, (state, action) => {
      state.loading = false;
      state.fTSuggestionBoxText = [];
      state.error = action.error.message;
    });
  },
});

export default ftOnBoardingSlice.reducer;
export const { visited } = ftOnBoardingSlice.actions;
